/**
 * Bystep Campus (docs/campus): public partnership form on `/campus#kerjasama`.
 * Server: `src/routes/api/public/campus-lead.ts` → table `campus_lead`; admin list at `/admin/campus`.
 */
import { api } from '#/lib/api'

export const CAMPUS_ROLES = [
  'dosen',
  'mahasiswa',
  'himpunan',
  'inkubator',
  'mentor',
  'lainnya',
] as const
export type CampusRole = (typeof CAMPUS_ROLES)[number]
export const CAMPUS_PARTNERSHIPS = [
  'kelas',
  'komunitas',
  'kampus',
  'perorangan',
  'lead',
] as const
export type CampusPartnership = (typeof CAMPUS_PARTNERSHIPS)[number]
export const CAMPUS_TRACKS = ['builder', 'solver', 'keduanya'] as const
export type CampusTrack = (typeof CAMPUS_TRACKS)[number]

export interface CampusLeadInput {
  email: string
  name?: string
  institution: string
  role: CampusRole
  partnership: CampusPartnership
  track?: CampusTrack
  teams?: number
  startTerm?: string
  phone?: string
  note?: string
  locale?: 'en' | 'id'
}

/** POST /api/public/campus-lead — rate limited 10/h per IP; upserts on (email, institution). */
export const submitCampusLead = (body: CampusLeadInput) =>
  api<{ ok: true }>('/api/public/campus-lead', { method: 'POST', json: body })
